import { render } from "./InfoButtons.vue?vue&type=template&id=654166b1"
import script from "./InfoButtons.vue?vue&type=script&lang=js"
export * from "./InfoButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__